import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Feedback',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Feedback',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Feedback',
    column_type: 'datetime',
  },
  phone: {
    model_name: 'Feedback',
    column_type: 'string',
  },
  description: {
    model_name: 'Feedback',
    column_type: 'text',
  },
  is_resolve: {
    model_name: 'Feedback',
    column_type: 'boolean',
  },
  solver: {
    model_name: 'Feedback',
    column_type: 'belongs_to',
    extra: {
      association_name: 'solver',
      model_name: 'AdminUser',
      foreign_key: 'solver_id',
    },
  },
  solver_id: {
    model_name: 'Feedback',
    column_type: 'belongs_to',
    extra: {
      association_name: 'solver',
      model_name: 'AdminUser',
      foreign_key: 'solver_id',
    },
  },
  images: {
    model_name: 'Feedback',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  images_with_audio: {
    model_name: 'Feedback',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
